export class Subscription {
	id: number;
	firstname: string;
	lastname: string;
	name: string;
	initials: string;
	gender: string;
	dob: string;
	email: string;
	zipcode: string;
	address: string;
	housenumber: string;
	city: string;
	country_id: string;
	mailinglist_id: number;
	subscription_language: string;
	shop_user_id: number;
	sub_email: boolean;
	sub_mail: boolean;

	constructor() {

	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/subscription.ts